import React from "react";
import VideoCard from "../Pages/VideoPage/VideoCard";
import Slider from "react-slick";
import { branch, flower, leaf, leaf2, mainLeaf } from "../assets";
import { BsBookmarkPlus } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const PatientsResults = () => {
  const navigate = useNavigate();
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 10000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <div id="patientResults">
      <div className="gradient"></div>
      <div className="gradient2"></div>

      <img src={mainLeaf} alt="" className="mainLeaf" />
      <img src={flower} alt="" className="mainLeaf2" />
      <img src={leaf2} alt="" className="mainLeaf3" />
      <img src={branch} alt="" className="mainLeaf4" />
      <div className="top">
        <h1>Patient Results</h1>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus,
          ipsa!
        </p>
      </div>
      <div className="results">
        <div className="result-row">
          <div className="det">
            <div className="title">
              <img src={leaf} alt="" />
              <h2>Aesthetic</h2>
            </div>
            <p>
              Aesthetic Treatments are all about enhancing your natural beauty.
              Sometimes called cosmetic treatments they are non-invasive,
              painless and require no downtime. They come in many forms
              including injectable and topical treatments.
            </p>
            <button
              className="booking"
              onClick={() => navigate("/appointment")}
            >
              <small>Book Appointment</small>
            </button>
          </div>
          <Slider {...settings} className="slider">
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
          </Slider>
        </div>
        <div className="result-row">
          <div className="det">
            <div className="title">
              <img src={leaf} alt="" />
              <h2>Anti-Aiging</h2>
            </div>
            <p>
              Anti-aging treatments such as Botox, you can get the smooth,
              line-free skin you want. Botox and Xeomin are two of the most
              effective treatments available for wrinkles on the market.
            </p>
            <button
              className="booking"
              onClick={() => navigate("/appointment")}
            >
              <small>Book Appointment</small>
            </button>
          </div>
          <Slider {...settings} className="slider">
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
          </Slider>
        </div>
        <div className="result-row">
          <div className="det">
            <div className="title">
              <img src={leaf} alt="" />
              <h2>Body Shapping</h2>
            </div>
            <p>
              Body sculpting, also known as body contouring, is a non-invasive
              treatment that reduces packets of fatty tissues. It also tightens
              skin in certain body parts without the need for surgery. Numerous
              factors contribute to why you have loose skin or excess body fat.
            </p>
            <button
              className="booking"
              onClick={() => navigate("/appointment")}
            >
              <small>Book Appointment</small>
            </button>
          </div>
          <Slider {...settings} className="slider">
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
          </Slider>
        </div>
        <div className="result-row">
          <div className="det">
            <div className="title">
              <img src={leaf} alt="" />
              <h2>Dermatology</h2>
            </div>
            <p>
              Definition. Dermatology is the medical discipline that is
              concerned with the diagnosis and treatment of diseases of the
              skin, hair, and nails in both children and adults. Specialists in
              dermatology are called dermatologists.
            </p>
            <button
              className="booking"
              onClick={() => navigate("/appointment")}
            >
              <small>Book Appointment</small>
            </button>
          </div>
          <Slider {...settings} className="slider">
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
          </Slider>
        </div>

        <div className="result-row">
          <div className="det">
            <div className="title">
              <img src={leaf} alt="" />
              <h2>Sexology</h2>
            </div>
            <p>
              Interdisciplinary science that focuses on diverse aspects of human
              sexual behaviour and sexuality, including sexual development,
              relationships, intercourse, sexual dysfunction, sexually
              transmitted diseases, and pathologies such as child sexual abuse
              or sexual addiction.
            </p>
            <button
              className="booking"
              onClick={() => navigate("/appointment")}
            >
              <small>Book Appointment</small>
            </button>
          </div>
          <Slider {...settings} className="slider">
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
            <div>
              <VideoCard />
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default PatientsResults;
